import { getReservationDetail } from 'api/order'
import { ITEM_STATUS_PENDING, ITEM_STATUS_CANCELLED } from 'constants/cart'
import asyncPoll from 'lib/promise/asyncPoll'

interface PollFlashReservationsStatusParams {
  checkIn: string
  orderItemId: string
  orderId: string
}

/** Polls for order reservation until it finds new reservation with matching cartItem checkIn date
 * used in flash change dates as reservation confirmation happens in redis job and takes a while
*/
const pollFlashReservationsStatus = async({ orderId, orderItemId, checkIn }: PollFlashReservationsStatusParams) => {
  return await asyncPoll({
    validateFunction: async({ reservation }) => {
      const newReservation = reservation?.startDate === checkIn && ![ITEM_STATUS_PENDING, ITEM_STATUS_CANCELLED].includes(reservation?.state ?? '')
      return newReservation
    },
    apiCall: () => getReservationDetail(orderItemId, orderId),
    maxTime: 120000,
    pollInterval: 1000,
  })
}

export default pollFlashReservationsStatus
